import { TextField } from "@mui/material"
import { DateTimePicker, MobileDateTimePicker } from "@mui/x-date-pickers"
import PropTypes from "prop-types"
import { useContext } from "react"
import { useIntl } from "react-intl"
import { DateSettingsContext } from "~/containers/InitializeApp/DateSettingsProvider"
import { useAcceptValueOnBlur } from "./useAcceptValueOnBlur"
import { useChangeValue } from "./useChangeValue"
import { useHelperText } from "./useHelperText"
import { useOnAccept } from "./useOnAccept"

const CustomPicker = ({
  formatDateTime,
  keyboardPickerEnabled,
  onBlur,
  onChange,
  value,
  errorProps: { error, forceDisplayFormError, showEmptyHelper },
  fullWidth,
  required,
  ...props
}) => {
  const { formatMessage } = useIntl()
  const { isHour12 } = useContext(DateSettingsContext)
  const [valueToAccept, changeValue] = useChangeValue(value, formatDateTime)
  const [helperText, setHelperText] = useHelperText(error, forceDisplayFormError, showEmptyHelper, formatMessage)
  const { fullDateFormat } = useContext(DateSettingsContext)
  const Picker = keyboardPickerEnabled ? DateTimePicker : MobileDateTimePicker

  const acceptValueOnBlur = useAcceptValueOnBlur(valueToAccept, changeValue, onChange, onBlur, formatDateTime)
  return (
    <Picker
      closeOnSelect
      showToolbar={false}
      ampm={isHour12}
      inputFormat={fullDateFormat}
      placeholder={fullDateFormat.toLowerCase()}
      onChange={changeValue}
      onAccept={useOnAccept(onChange, formatDateTime)}
      onError={setHelperText}
      value={valueToAccept}
      toolbarTitle={formatMessage({ id: "common.datetimeChoose" })}
      renderInput={params => (
        <TextField
          {...params}
          error={!!helperText && helperText !== " "}
          data-test-id="dateTimePickerField"
          onBlur={acceptValueOnBlur}
          required={required}
          fullWidth={fullWidth}
          helperText={helperText}
          variant="standard"
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={{
            ...params.inputProps,
            // eslint-disable-next-line no-useless-computed-key
            ["data-test-id"]: Picker.render.name,
            type: "text",
            placeholder: fullDateFormat.toLowerCase(),
          }}
        />
      )}
      {...props}
    />
  )
}

CustomPicker.propTypes = {
  errorProps: PropTypes.object,
  formatDateTime: PropTypes.string,
  keyboardPickerEnabled: PropTypes.bool,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  variant: PropTypes.string,
  fullWidth: PropTypes.bool,
  required: PropTypes.bool,
}

CustomPicker.defaultProps = {
  formatDateTime: "",
  onBlur: undefined,
  keyboardPickerEnabled: true,
  value: null,
  variant: "inline",
  errorProps: { error: null, forceDisplayFormError: false, showEmptyHelper: false },
  fullWidth: false,
  required: false,
}

export default CustomPicker
